// // import React, { useState, useEffect } from "react";
// // import { MainLayout } from "../layout/MainLayout";
// // import { ToastContainer, toast } from "react-toastify";
// // import {
// //   Search,
// //   ChevronRight,
// //   X,
// //   Loader,
// //   AlertCircle,
// //   Users,
// // } from "lucide-react";

// // const ProjectUserList = () => {
// //   const [expandedUserId, setExpandedUserId] = useState(null);
// //   const [searchTerm, setSearchTerm] = useState("");
// //   const [users, setUsers] = useState([]);
// //   const [loading, setLoading] = useState(false);
// //   const [error, setError] = useState(null);

// //   const token = localStorage.getItem("token");
// //   const apiRoot = process.env.REACT_APP_API_ROOT;

// //   const toggleExpandUser = (userId) => {
// //     setExpandedUserId(expandedUserId === userId ? null : userId);
// //   };

// //   const fetchUsers = async () => {
// //     setLoading(true);
// //     setError(null);

// //     try {
// //       const response = await fetch(
// //         `${apiRoot}/api/project_assignment/user_projects/`,
// //         {
// //           method: "GET",
// //           headers: {
// //             Authorization: `Bearer ${token}`,
// //             "Content-Type": "application/json",
// //           },
// //         }
// //       );

// //       if (!response.ok) {
// //         throw new Error("Failed to fetch: " + response.statusText);
// //       }

// //       const data = await response.json();
// //       setUsers(data.filter((user) => user.projects.length > 0));
// //     } catch (err) {
// //       setError(err.message);
// //     } finally {
// //       setLoading(false);
// //     }
// //   };

// //   useEffect(() => {
// //     fetchUsers();
// //   }, []);

// //   const usersToShow =
// //     searchTerm.length >= 3
// //       ? users.filter((user) =>
// //           user.projects.some((projectName) =>
// //             projectName.toLowerCase().includes(searchTerm.toLowerCase())
// //           )
// //         )
// //       : users;

// //   const revokeAccess = async (userName, projectName) => {
// //     try {
// //       const response = await fetch(
// //         `${apiRoot}/api/project_assignment/revoke_project_access/?user=${userName}&project=${projectName}`,
// //         {
// //           method: "DELETE",
// //           headers: {
// //             Authorization: `Bearer ${token}`,
// //             "Content-Type": "application/json",
// //           },
// //         }
// //       );

// //       if (response.status === 204) {
// //         toast.success(`Access revoked for ${userName} on ${projectName}`);
// //         fetchUsers();
// //         return;
// //       }

// //       const result = await response.json();
// //       if (result.error) {
// //         throw new Error(result.error);
// //       } else {
// //         toast.success(`Access revoked for ${userName} on ${projectName}`);
// //         fetchUsers();
// //       }
// //     } catch (err) {
// //       toast.error(`Failed to revoke access: ${err.message}`);
// //     }
// //   };

// //   return (
// //     <MainLayout>
// //       <div className="min-h-screen bg-gray-50 py-8">
// //         <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
// //           <div className="bg-white rounded-xl shadow-sm overflow-hidden">
// //             {/* Header */}
// //             <div className="px-6 py-8 border-b border-gray-200">
// //               <div className="flex items-center justify-between">
// //                 <div>
// //                   <h1 className="text-2xl font-bold text-gray-900">
// //                     Project User Management
// //                   </h1>
// //                   <p className="mt-1 text-gray-600">
// //                     Manage user access to projects
// //                   </p>
// //                 </div>
// //                 <div className="p-3 bg-blue-50 rounded-lg">
// //                   <Users className="w-6 h-6 text-blue-600" />
// //                 </div>
// //               </div>
// //             </div>

// //             {/* Search Section */}
// //             <div className="p-6 border-b border-gray-200 bg-gray-50">
// //               <div className="relative max-w-md mx-auto">
// //                 <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
// //                   <Search className="h-5 w-5 text-gray-400" />
// //                 </div>
// //                 <input
// //                   type="text"
// //                   placeholder="Type at least 3 characters to search projects..."
// //                   value={searchTerm}
// //                   onChange={(e) => setSearchTerm(e.target.value)}
// //                   className="block w-full pl-10 pr-3 py-3 border border-gray-300 rounded-lg
// //                     focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-colors"
// //                 />
// //               </div>
// //             </div>

// //             {/* Users List */}
// //             <div className="p-6">
// //               {loading ? (
// //                 <div className="flex items-center justify-center py-12">
// //                   <Loader className="w-8 h-8 text-blue-500 animate-spin" />
// //                 </div>
// //               ) : error ? (
// //                 <div className="flex items-center gap-2 p-4 bg-red-50 rounded-lg text-red-700">
// //                   <AlertCircle className="w-5 h-5 flex-shrink-0" />
// //                   <p>{error}</p>
// //                 </div>
// //               ) : usersToShow.length === 0 ? (
// //                 <div className="text-center py-12 text-gray-500">
// //                   No users found matching your search criteria.
// //                 </div>
// //               ) : (
// //                 <div className="grid gap-4 md:grid-cols-2 lg:grid-cols-3">
// //                   {usersToShow.map((user) => (
// //                     <div
// //                       key={user.id}
// //                       className="bg-white rounded-lg border border-gray-200 overflow-hidden
// //                         hover:shadow-md transition-shadow"
// //                     >
// //                       {/* User Header */}
// //                       <div
// //                         onClick={() => toggleExpandUser(user.id)}
// //                         className="flex items-center justify-between p-4 cursor-pointer
// //                           hover:bg-gray-50 border-b border-gray-200"
// //                       >
// //                         <span className="font-medium text-gray-900">
// //                           {user.name}
// //                         </span>
// //                         <ChevronRight
// //                           className={`w-5 h-5 text-gray-400 transition-transform duration-200
// //                             ${expandedUserId === user.id ? "rotate-90" : ""}`}
// //                         />
// //                       </div>

// //                       {/* Projects List */}
// //                       <div
// //                         className={`transition-all duration-200 overflow-hidden
// //                           ${
// //                             expandedUserId === user.id ? "max-h-96" : "max-h-0"
// //                           }`}
// //                       >
// //                         <div className="p-4 space-y-2">
// //                           {user.projects.map((project, index) => (
// //                             <div
// //                               key={index}
// //                               className="flex items-center justify-between bg-gray-50
// //                                 px-3 py-2 rounded-lg text-sm"
// //                             >
// //                               <span className="text-gray-700">{project}</span>
// //                               <button
// //                                 onClick={(e) => {
// //                                   e.stopPropagation();
// //                                   revokeAccess(user.id, project);
// //                                 }}
// //                                 className="p-1 hover:bg-red-100 rounded-full
// //                                   text-red-600 transition-colors"
// //                                 title="Revoke access"
// //                               >
// //                                 <X className="w-4 h-4" />
// //                               </button>
// //                             </div>
// //                           ))}
// //                         </div>
// //                       </div>
// //                     </div>
// //                   ))}
// //                 </div>
// //               )}
// //             </div>
// //           </div>
// //         </div>
// //       </div>
// //       <ToastContainer position="top-right" autoClose={5000} />
// //     </MainLayout>
// //   );
// // };

// // export default ProjectUserList;
// import React, { useState, useEffect } from "react";
// import { useParams } from "react-router-dom";
// import { MainLayout } from "../layout/MainLayout";
// import { ToastContainer, toast } from "react-toastify";
// import {
//   Search,
//   ChevronRight,
//   X,
//   Loader,
//   AlertCircle,
//   Users,
// } from "lucide-react";

// const ProjectUserList = () => {
//   const [expandedUserId, setExpandedUserId] = useState(null);
//   const [searchTerm, setSearchTerm] = useState("");
//   const [users, setUsers] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const [error, setError] = useState(null);

//   const token = localStorage.getItem("token");
//   const apiRoot = process.env.REACT_APP_API_ROOT;

//   const toggleExpandUser = (userId) => {
//     setExpandedUserId(expandedUserId === userId ? null : userId);
//   };

//   const fetchUsers = async () => {
//     setLoading(true);
//     setError(null);

//     try {
//       const response = await fetch(
//         `${apiRoot}/api/project_assignment/user_projects/`,
//         {
//           method: "GET",
//           headers: {
//             Authorization: `Bearer ${token}`,
//             "Content-Type": "application/json",
//           },
//         }
//       );

//       if (!response.ok) {
//         throw new Error("Failed to fetch: " + response.statusText);
//       }

//       const data = await response.json();
//       setUsers(data.filter((user) => user.projects.length > 0));
//     } catch (err) {
//       setError(err.message);
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     fetchUsers();
//   }, []);

//   const usersToShow =
//     searchTerm.length >= 3
//       ? users.filter((user) =>
//           user.projects.some((projectName) =>
//             projectName.toLowerCase().includes(searchTerm.toLowerCase())
//           )
//         )
//       : users;

//   const revokeAccess = async (userName, projectName) => {
//     try {
//       const response = await fetch(
//         `${apiRoot}/api/project_assignment/revoke_project_access/?user=${userName}&project=${projectName}`,
//         {
//           method: "DELETE",
//           headers: {
//             Authorization: `Bearer ${token}`,
//             "Content-Type": "application/json",
//           },
//         }
//       );

//       if (response.status === 204) {
//         toast.success(`Access revoked for ${userName} on ${projectName}`);
//         fetchUsers();
//         return;
//       }

//       const result = await response.json();
//       if (result.error) {
//         throw new Error(result.error);
//       } else {
//         toast.success(`Access revoked for ${userName} on ${projectName}`);
//         fetchUsers();
//       }
//     } catch (err) {
//       toast.error(`Failed to revoke access: ${err.message}`);
//     }
//   };

//   return (
//     <MainLayout>
//       <div className="min-h-screen bg-gray-50 py-8">
//         <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
//           <div className="bg-white rounded-xl shadow-sm overflow-hidden">
//             {/* Header */}
//             <div className="px-6 py-8 border-b border-gray-200">
//               <div className="flex items-center justify-between">
//                 <div>
//                   <h1 className="text-2xl font-bold text-gray-900">
//                     Project User Management
//                   </h1>
//                   <p className="mt-1 text-gray-600">
//                     Manage user access to projects
//                   </p>
//                 </div>
//                 <div className="p-3 bg-blue-50 rounded-lg">
//                   <Users className="w-6 h-6 text-blue-600" />
//                 </div>
//               </div>
//             </div>

//             {/* Search Section */}
//             <div className="p-6 border-b border-gray-200 bg-gray-50">
//               <div className="relative max-w-md mx-auto">
//                 <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
//                   <Search className="h-5 w-5 text-gray-400" />
//                 </div>
//                 <input
//                   type="text"
//                   placeholder="Type at least 3 characters to search projects..."
//                   value={searchTerm}
//                   onChange={(e) => setSearchTerm(e.target.value)}
//                   className="block w-full pl-10 pr-3 py-3 border border-gray-300 rounded-lg
//                     focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-colors"
//                 />
//               </div>
//             </div>

//             {/* Users List */}
//             <div className="p-6">
//               {loading ? (
//                 <div className="flex items-center justify-center py-12">
//                   <Loader className="w-8 h-8 text-blue-500 animate-spin" />
//                 </div>
//               ) : error ? (
//                 <div className="flex items-center gap-2 p-4 bg-red-50 rounded-lg text-red-700">
//                   <AlertCircle className="w-5 h-5 flex-shrink-0" />
//                   <p>{error}</p>
//                 </div>
//               ) : usersToShow.length === 0 ? (
//                 <div className="text-center py-12 text-gray-500">
//                   No users found matching your search criteria.
//                 </div>
//               ) : (
//                 <div className="grid gap-4 md:grid-cols-2 lg:grid-cols-3">
//                   {usersToShow.map((user) => (
//                     <div
//                       key={user.id}
//                       className="bg-white rounded-lg border border-gray-200 overflow-hidden 
//                         hover:shadow-md transition-shadow"
//                     >
//                       {/* User Header */}
//                       <div
//                         onClick={() => toggleExpandUser(user.id)}
//                         className="flex items-center justify-between p-4 cursor-pointer 
//                           hover:bg-gray-50 border-b border-gray-200"
//                       >
//                         <span className="font-medium text-gray-900">
//                           {user.name}
//                         </span>
//                         <ChevronRight
//                           className={`w-5 h-5 text-gray-400 transition-transform duration-200
//                             ${expandedUserId === user.id ? "rotate-90" : ""}`}
//                         />
//                       </div>

//                       {/* Projects List */}
//                       <div
//                         className={`transition-all duration-200 overflow-hidden
//                           ${
//                             expandedUserId === user.id ? "max-h-96" : "max-h-0"
//                           }`}
//                       >
//                         <div className="p-4 space-y-2">
//                           {user.projects.map((project, index) => (
//                             <div
//                               key={index}
//                               className="flex items-center justify-between bg-gray-50 
//                                 px-3 py-2 rounded-lg text-sm"
//                             >
//                               <span className="text-gray-700">{project}</span>
//                               <button
//                                 onClick={(e) => {
//                                   e.stopPropagation();
//                                   revokeAccess(user.id, project);
//                                 }}
//                                 className="p-1 hover:bg-red-100 rounded-full 
//                                   text-red-600 transition-colors"
//                                 title="Revoke access"
//                               >
//                                 <X className="w-4 h-4" />
//                               </button>
//                             </div>
//                           ))}
//                         </div>
//                       </div>
//                     </div>
//                   ))}
//                 </div>
//               )}
//             </div>
//           </div>
//         </div>
//       </div>
//       <ToastContainer position="top-right" autoClose={5000} />
//     </MainLayout>
//   );
// };

// export default ProjectUserList;
import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { MainLayout } from "../layout/MainLayout";
import { ToastContainer, toast } from "react-toastify";
import {
  Search,
  ChevronRight,
  ChevronDown,
  X,
  Loader,
  AlertCircle,
  Users,
  Shield,
  FolderOpen,
  User,
  RefreshCw,
  CheckCircle2
} from "lucide-react";

const ProjectUserList = () => {
  const [expandedUserId, setExpandedUserId] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [revokeLoading, setRevokeLoading] = useState({});

  const token = localStorage.getItem("token");
  const apiRoot = process.env.REACT_APP_API_ROOT;

  const toggleExpandUser = (userId) => {
    setExpandedUserId(expandedUserId === userId ? null : userId);
  };

  const fetchUsers = async () => {
    setLoading(true);
    setError(null);

    try {
      const response = await fetch(
        `${apiRoot}/api/project_assignment/user_projects/`,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      if (!response.ok) {
        throw new Error("Failed to fetch: " + response.statusText);
      }

      const data = await response.json();
      setUsers(data.filter((user) => user.projects.length > 0));
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchUsers();
  }, []);

  const usersToShow =
    searchTerm.length >= 3
      ? users.filter((user) =>
          user.projects.some((projectName) =>
            projectName.toLowerCase().includes(searchTerm.toLowerCase())
          )
        )
      : users;

  const revokeAccess = async (userName, projectName) => {
    const revokeKey = `${userName}-${projectName}`;
    setRevokeLoading(prev => ({ ...prev, [revokeKey]: true }));

    try {
      const response = await fetch(
        `${apiRoot}/api/project_assignment/revoke_project_access/?user=${userName}&project=${projectName}`,
        {
          method: "DELETE",
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      if (response.status === 204) {
        toast.success(`Access revoked for ${userName} on ${projectName}`);
        fetchUsers();
        return;
      }

      const result = await response.json();
      if (result.error) {
        throw new Error(result.error);
      } else {
        toast.success(`Access revoked for ${userName} on ${projectName}`);
        fetchUsers();
      }
    } catch (err) {
      toast.error(`Failed to revoke access: ${err.message}`);
    } finally {
      setRevokeLoading(prev => ({ ...prev, [revokeKey]: false }));
    }
  };

  const UserCard = ({ user }) => {
    const isExpanded = expandedUserId === user.id;
    
    return (
      <div className="bg-white rounded-xl shadow-md border border-slate-200 overflow-hidden hover:shadow-lg transition-all duration-300">
        {/* User Header */}
        <div
          onClick={() => toggleExpandUser(user.id)}
          className="bg-slate-50 hover:bg-slate-100 p-4 cursor-pointer border-b border-slate-200 transition-colors duration-200"
        >
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-3">
              <div className="inline-flex items-center justify-center w-10 h-10 bg-blue-100 rounded-lg">
                <User className="w-5 h-5 text-blue-600" />
              </div>
              <div>
                <h3 className="font-semibold text-slate-800 text-sm">{user.name}</h3>
                <p className="text-slate-500 text-xs">{user.projects.length} project{user.projects.length !== 1 ? 's' : ''}</p>
              </div>
            </div>
            {isExpanded ? (
              <ChevronDown className="w-5 h-5 text-slate-400 transition-transform duration-200" />
            ) : (
              <ChevronRight className="w-5 h-5 text-slate-400 transition-transform duration-200" />
            )}
          </div>
        </div>

        {/* Projects List */}
        <div className={`transition-all duration-300 overflow-hidden ${
          isExpanded ? "max-h-96 opacity-100" : "max-h-0 opacity-0"
        }`}>
          <div className="p-4 space-y-3">
            <h4 className="text-sm font-semibold text-slate-700 flex items-center gap-2">
              <Shield className="w-4 h-4 text-green-600" />
              Assigned Projects
            </h4>
            {user.projects.map((project, index) => {
              const revokeKey = `${user.id}-${project}`;
              const isRevoking = revokeLoading[revokeKey];
              
              return (
                <div
                  key={index}
                  className="flex items-center justify-between bg-slate-50 hover:bg-slate-100 
                    px-4 py-3 rounded-lg transition-colors duration-200 border border-slate-200"
                >
                  <div className="flex items-center gap-3">
                    <FolderOpen className="w-4 h-4 text-green-600" />
                    <span className="text-slate-700 font-medium text-sm">{project}</span>
                  </div>
                  <button
                    onClick={(e) => {
                      e.stopPropagation();
                      revokeAccess(user.id, project);
                    }}
                    disabled={isRevoking}
                    className="group p-2 hover:bg-red-100 rounded-lg text-red-600 
                      transition-all duration-200 disabled:opacity-50"
                    title="Revoke access"
                  >
                    {isRevoking ? (
                      <Loader className="w-4 h-4 animate-spin" />
                    ) : (
                      <X className="w-4 h-4 group-hover:scale-110 transition-transform duration-200" />
                    )}
                  </button>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    );
  };

  return (
    <MainLayout>
      <div className="min-h-screen bg-gradient-to-br from-slate-50 via-blue-50 to-indigo-50 py-8">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          
          {/* Page Header */}
          <div className="text-center mb-12">
            <div className="inline-flex items-center justify-center w-20 h-20 bg-gradient-to-br from-blue-600 to-indigo-600 rounded-2xl mb-6 shadow-lg">
              <Shield className="w-10 h-10 text-white" />
            </div>
            <h1 className="text-4xl font-bold bg-gradient-to-r from-slate-800 to-slate-600 bg-clip-text text-transparent mb-4">
              Project User Management
            </h1>
            <p className="text-lg text-slate-600 max-w-2xl mx-auto">
              Manage user access permissions and project assignments
            </p>
          </div>

          {/* Main Content Card */}
          <div className="bg-white rounded-2xl shadow-xl border border-slate-200 overflow-hidden">
            {/* Card Header */}
            <div className="bg-gradient-to-br from-blue-600 to-indigo-600 p-6 relative overflow-hidden">
              <div className="absolute inset-0 bg-gradient-to-br from-white/20 to-transparent"></div>
              <div className="relative z-10">
                <div className="flex items-center justify-between">
                  <div className="flex items-center gap-3">
                    <div className="inline-flex items-center justify-center w-12 h-12 bg-white/20 backdrop-blur-sm rounded-xl">
                      <Users className="w-6 h-6 text-white" />
                    </div>
                    <div>
                      <h2 className="text-xl font-bold text-white">User Access Control</h2>
                      <p className="text-white/80 text-sm">View and manage project permissions</p>
                    </div>
                  </div>
                  <button
                    onClick={fetchUsers}
                    disabled={loading}
                    className="inline-flex items-center gap-2 px-4 py-2 bg-white/20 backdrop-blur-sm 
                      rounded-xl text-white hover:bg-white/30 transition-colors duration-200 disabled:opacity-50"
                  >
                    <RefreshCw className={`w-4 h-4 ${loading ? 'animate-spin' : ''}`} />
                    Refresh
                  </button>
                </div>
              </div>
              
              {/* Decorative Elements */}
              <div className="absolute -top-8 -right-8 w-24 h-24 bg-white/10 rounded-full"></div>
              <div className="absolute -bottom-4 -left-4 w-16 h-16 bg-white/10 rounded-full"></div>
            </div>

            {/* Search Section */}
            <div className="p-6 bg-slate-50 border-b border-slate-200">
              <div className="max-w-md mx-auto">
                <div className="relative">
                  <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                    <Search className="h-5 w-5 text-slate-400" />
                  </div>
                  <input
                    type="text"
                    placeholder="Search projects (min 3 characters)..."
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                    className="w-full pl-10 pr-4 py-3 border border-slate-300 rounded-xl focus:ring-2 
                      focus:ring-blue-500 focus:border-blue-500 transition-all duration-200 bg-white"
                  />
                </div>
                <p className="text-sm text-slate-500 mt-2 text-center">
                  {searchTerm.length >= 3 
                    ? `Showing results for "${searchTerm}"` 
                    : "Enter at least 3 characters to search projects"
                  }
                </p>
              </div>
            </div>

            {/* Content Area */}
            <div className="p-6">
              {loading ? (
                <div className="flex flex-col items-center justify-center py-16">
                  <Loader className="w-8 h-8 text-blue-600 animate-spin mb-4" />
                  <p className="text-slate-600">Loading user data...</p>
                </div>
              ) : error ? (
                <div className="flex items-center gap-3 p-6 bg-red-50 rounded-xl border border-red-200 text-red-700">
                  <AlertCircle className="w-6 h-6 flex-shrink-0" />
                  <div>
                    <h3 className="font-semibold">Error loading data</h3>
                    <p className="text-sm">{error}</p>
                  </div>
                </div>
              ) : usersToShow.length === 0 ? (
                <div className="text-center py-16">
                  <div className="inline-flex items-center justify-center w-16 h-16 bg-slate-100 rounded-full mb-4">
                    <Users className="w-8 h-8 text-slate-400" />
                  </div>
                  <h3 className="text-lg font-semibold text-slate-700 mb-2">No users found</h3>
                  <p className="text-slate-500">
                    {searchTerm.length >= 3 
                      ? "No users found matching your search criteria."
                      : "No users with project assignments found."
                    }
                  </p>
                </div>
              ) : (
                <>
                  {/* Statistics Bar */}
                  <div className="mb-6 p-4 bg-slate-50 rounded-xl border border-slate-200">
                    <div className="flex items-center justify-between">
                      <div className="flex items-center gap-2">
                        <CheckCircle2 className="w-5 h-5 text-green-600" />
                        <span className="text-sm font-semibold text-slate-700">
                          {usersToShow.length} user{usersToShow.length !== 1 ? 's' : ''} with project access
                        </span>
                      </div>
                      <div className="text-sm text-slate-500">
                        Total projects: {usersToShow.reduce((total, user) => total + user.projects.length, 0)}
                      </div>
                    </div>
                  </div>

                  {/* Users Grid */}
                  <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-3">
                    {usersToShow.map((user) => (
                      <UserCard key={user.id} user={user} />
                    ))}
                  </div>
                </>
              )}
            </div>
          </div>
        </div>
      </div>
      <ToastContainer 
        position="top-right" 
        autoClose={5000}
        className="mt-16"
        toastClassName="rounded-xl"
      />
    </MainLayout>
  );
};

export default ProjectUserList;